import { api, apiFile, base_url_v1, base_url_v2 } from "./api";

export const LocationApi = async () => {
    const data = await api({ url: `${base_url_v2}company/qr-codes`, method: "GET", token: true })
    return data;
}

export const AddLocationApi = async (formRef: any, position: any) => {
    let postData = JSON.stringify({
        'name': formRef.current['name'].value,
        'description': formRef.current['description'].value,
        'distance': String(formRef.current['distance'].value),
        'lat': position[0],
        'lng': position[1],

    })
    const data = await api({ url: `${base_url_v2}company/qr-codes`, method: "POST", token: true, body: postData })
    return data;
}

export const SingleLocationApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/qr-codes/${id}`, method: "GET", token: true })
    return data;
}

export const DeleteLocationApi = async (id: any) => {
    const data = await api({ url: `${base_url_v2}company/qr-codes/${id}`, method: "DELETE", token: true })
    return data;
}


export const EditLocationApi  = async (formRef: any, position:any , detailData:any) => {
    let postData = JSON.stringify({
        'name': formRef.current['name'].value,
        'description': formRef.current['description'].value,
        'distance': String(formRef.current['distance'].value),
        'lat': position[0],
        'lng': position[1],

    })
    const data = await api({ url: `${base_url_v2}company/qr-codes/${detailData.id}`, method: "PUT", token: true, body: postData })
    return data;
}

export const QRExport = async (id:any) => {
    const data = await apiFile({ url: `${base_url_v2}company/qr-codes/${id}/image`, method: "GET", token: true })
    return data;
}
